module.exports = __webpack_public_path__ + "static/media/deusto.f33df0d3.png";